import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import { combineLatest, Observable, of } from 'rxjs';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { ResetTheme, SetNavTransparency, SetTheme } from 'src/app/store';

@Injectable({ providedIn: 'root' })
export class ProductDetailGuard {
  constructor(private store: Store, private router: Router, private route: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkStore(route);
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(fromStore.getProductsLoading).pipe(
      withLatestFrom(
        this.store.select(fromStore.getProductsDetailEntities),
        this.store.select(fromStore.getSelectedproduct),
        this.store.select(fromStore.getProductError)
      ),
      tap(([loading, loadedEntities, product, error]) => {
        const routeHandle = route.params['productHandle'];

        if (!loadedEntities.includes(routeHandle) && !loading) {
          this.store.dispatch(fromStore.LoadProductByHandle({ handle: routeHandle, loadDetails: true }));
          // TODO subtheme gray topbar
          this.store.dispatch(ResetTheme());
          this.store.dispatch(SetNavTransparency({ transparent: false }));
        }
      }),
      map(([loading, loaded, product, error]) => {
        const routeHandle = route.params['productHandle'];
        if (loaded.includes(routeHandle) && product && !loading && product?.handle !== route.params['productHandle']) {
          let url = ['/', 'products', product.handle];
          if (route.params['collectionHandle']) {
            url = ['/', 'collections', route.params['collectionHandle'], product.handle];
          }

          const newUrl = this.router.createUrlTree(url, {
            relativeTo: this.route,
            queryParams: route.queryParams,
          });
          return newUrl;
        }

        return (loaded.includes(routeHandle) && !loading) || (error && !loading);
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
